// extracted by mini-css-extract-plugin
module.exports = {"mapAddressContainer":"MapAddress_mapAddressContainer__1fXYx","geoCard":"MapAddress_geoCard__1-VY1"};